(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sogna-booking-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sogna-booking]');
    const service = document.getElementById('BookingService');

    if (!root || !service) return;

    const formSection = document.getElementById('sogna-booking-form');
    const partySize = document.getElementById('BookingPartySize');
    const status = root.querySelector('[data-booking-selection-status]');
    const serviceButtons = [...root.querySelectorAll('[data-booking-service]')];
    const typeButtons = [...root.querySelectorAll('.sogna-booking__type[data-booking-service]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const bookingType = new URLSearchParams(window.location.search).get('type');
    const serviceByType = {
      suit: 'Suit fitting',
      tuxedo: 'Tuxedo fitting',
      wedding: 'Wedding party',
      group: 'Wedding party',
      occasion: 'Occasion dress styling',
      'made-to-measure': 'Made to measure',
      alterations: 'Alterations'
    };

    const syncServiceButtons = (value) => {
      typeButtons.forEach((button) => {
        const selected = button.dataset.bookingService === value
          || (button.dataset.bookingType === 'suit' && value === 'Tuxedo fitting');
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    const selectService = (button, moveToForm) => {
      service.value = button.dataset.bookingService;
      service.dispatchEvent(new Event('change', { bubbles: true }));
      syncServiceButtons(service.value);

      if (status) status.textContent = button.dataset.selectedMessage || '';

      if (button.dataset.bookingType === 'wedding' && partySize && partySize.value === '1') {
        partySize.value = '2';
      }

      if (moveToForm && formSection) {
        formSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(() => service.focus({ preventScroll: true }), reduceMotion ? 0 : 500);
      }
    };

    serviceButtons.forEach((button) => {
      button.addEventListener('click', () => selectService(button, true));
    });

    service.addEventListener('change', () => syncServiceButtons(service.value));

    if (serviceByType[bookingType]) {
      service.value = serviceByType[bookingType];
      syncServiceButtons(service.value);

      if (bookingType === 'group' && partySize) partySize.value = '5+';
    }

    const form = document.getElementById('SognaBookingForm');
    const submit = form?.querySelector('[type="submit"]');

    form?.addEventListener('submit', () => {
      if (!form.checkValidity() || !submit) return;

      submit.disabled = true;
      const label = submit.querySelector('span');
      if (label) label.textContent = submit.dataset.sendingLabel;
    });

    root.querySelector('[data-booking-success]')?.focus();
  })();
  } catch(e) { console.error(e); }
})();

})();
